@if ((keyboardActive$ | async) !== true) {
  <div class="bottom-offset" [class]="type()"></div>
}
